import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcMaximize(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.481 13.47a.75.75 0 1 1 1.061 1.06l-4.72 4.72H10a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75v-6a.75.75 0 0 1 1.5 0v4.201zM20.012 3.25a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0V5.799L14.53 10.53a.75.75 0 1 1-1.06-1.06l4.72-4.72h-4.178a.75.75 0 0 1 0-1.5z"
  }));
}
var IcMaximize = createNolIcon(/*#__PURE__*/forwardRef(SvgIcMaximize));

export { IcMaximize as I };
